<template>
    <b-modal v-model="editModalShow" modal-class="c-edit-budget-line" title="Editar" centered>
        <template v-if="budgetLine">
            <budget-line v-if="eco" @change-action="changeTipoPlanta" :changing="changingEcoType" :show-change-btn="!forceTipoPlanta">
                <template v-slot>
                    Ecológica
                </template>
                <template v-slot:icon>
                    <img src="/img/iconos/icon_ecologico.svg" alt="Ecológico">
                </template>
                <template v-slot:info>
                    <img v-b-modal.modal-eco src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                    <modal-block v-cloak title="Ecológico" :href="route('help.details','ecologica')" desing="ecologico" refer="eco">
                        Plantas con certificado ecológico producidas bajo
                        la normativa de producción ecológica UE 834/2007.
                    </modal-block>
                </template>
                <template v-slot:extra v-if="changingEcoType">
                    <eco-type-buttons v-model="edited.eco"></eco-type-buttons>
                </template>
            </budget-line>
            <budget-line v-else @change-action="changeTipoPlanta" :changing="changingEcoType" :show-change-btn="!forceTipoPlanta">
                <template v-slot>
                    Residuo cero
                </template>
                <template v-slot:icon>
                </template>
                <template v-slot:info>
                    <img v-b-modal.modal-residuocero src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                    <modal-block v-cloak title="Residuo Cero" :href="route('help.details','residuo-cero')" desing="residuocero" refer="residuocero">
                        Planta para producción convencional cultivada con productos químicos de bajo impacto.
                    </modal-block>
                </template>
                <template v-slot:extra v-if="changingEcoType">
                    <eco-type-buttons v-model="edited.eco"></eco-type-buttons>
                </template>
            </budget-line>
            <budget-line @change-action="changeVariety" :changing="changingVariety" ref="varietyLine">
                <template v-slot>
                    <div v-if="variety">
                        {{ variety.mote.especie.nombre }}
                        <div style="font-weight: normal">
                            {{ variety.mote.nombre }}
                        </div>
                        <div style="font-weight: normal">
                            {{ variety.nombre }}
                        </div>
                    </div>
                </template>
                <template v-slot:icon>
                    <img src="/img/iconos/custom_default.svg" alt="Variedad">
                </template>
                <template v-slot:extra v-if="changingVariety">
                    <variety-select-input v-model="edited.varietyId" @variety-data-changed="setVarietyObj"
                                          :budget-line-date="budgetLineDate"
                                          @other-date="otherDate" @date-selected="dateSelected"
                                          @date-problem="dateProblemChanged" :dateChanged.sync="dateChanged"
                                          @date-block-changed="dateBlockChanged" :show-min-order="showMinOrder"
                                          :injertable="edited.injerto" :filters.sync="filters"
                                          :block-to-date="blockToDate" :date="date"
                    ></variety-select-input>
                </template>
                <template v-slot:info>
                    <img v-b-modal.modal-variedad src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                    <modal-block v-cloak title="Variedad" desing="ecologico" refer="variedad">
                        Variedades de plantas hortícolas disponibles
                    </modal-block>
                </template>
            </budget-line>
            <template v-if="canInjerto">
                <budget-line v-if="injertada" @change-action="changeInjertoPlanta" :changing="changingInjertoType">
                    <template v-slot>
                        Injertada
                    </template>
                    <template v-slot:icon>
                        <img src="/img/iconos/icon_injertada.svg" alt="Injertada">
                    </template>
                    <template v-slot:info>
                        <img v-b-modal.modal-inj src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                        <modal-block v-cloak title="Especies" :href="route('help.details','injerto')"  desing="ecologico" refer="inj">
                            Tomate, Pimiento, Melón, Sandía, Pepino, Calabacín, Alficoz, Berenjena
                        </modal-block>
                    </template>
                    <template v-slot:extra v-if="changingInjertoType">
                        <injerto-type-buttons v-model="edited.injerto"></injerto-type-buttons>
                    </template>
                </budget-line>
                <budget-line v-else-if="injertada !== null" @change-action="changeInjertoPlanta" :changing="changingInjertoType">
                    <template v-slot>
                        Sin injertar
                    </template>
                    <template v-slot:icon>
                        <img src="/img/iconos/icon_sin_injertar.svg" alt="Injertada">
                    </template>
                    <template v-slot:info>
                        <span></span>
                    </template>
                    <template v-slot:extra v-if="changingInjertoType">
                        <injerto-type-buttons v-model="edited.injerto"></injerto-type-buttons>
                    </template>
                </budget-line>
            </template>
            <budget-line v-if="edited.injerto" @change-action="changeVarietyPie" :changing="changingVarietyPie" ref="varietyPieLine">
                <template v-slot>
                    <div v-if="varietyPie">
                        {{ varietyPie.mote.especie.nombre }}
                        <div style="font-weight: normal">
                            {{ varietyPie.mote.nombre }}
                        </div>
                        <div style="font-weight: normal">
                            {{ varietyPie.nombre }}
                        </div>
                    </div>
                </template>
                <template v-slot:icon>
                    <img src="/img/iconos/icon_variedad_pie.svg" alt="Variedad pie">
                </template>
                <template v-slot:extra v-if="changingVarietyPie">
                    <injerto-select-input v-model="edited.varietyPieId"
                                          :budget-line-date="budgetLineDate"
                                          @other-date="otherDate" @date-selected="dateSelected"
                                          @date-problem="dateProblemChanged" :dateChanged.sync="dateChanged"
                                          @date-block-changed="dateBlockChanged" :mainVarietyId="edited.varietyId"
                                          :filters.sync="filters" :no-price-message="noPriceInjerto"
                                          :variety-data-prop.sync="varietyPie"
                                          :block-to-date="blockToDate" :date="date"
                    ></injerto-select-input>
                </template>
                <template v-slot:info>
                    <img v-b-modal.modal-variedadpie src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                    <modal-block v-cloak title="Variedad de pie" desing="ecologico" refer="variedadpie">
                        Variedad de patrón sobre la que se injertará la variedad seleccionada
                    </modal-block>
                </template>
            </budget-line>
            <budget-line @change-action="changeFecha" :changing="changingFecha" ref="dateLine">
                <template v-slot>
                    Fecha de entrega <br>
                    <span style="font-weight: normal">{{ dateFormatted }}</span>
                </template>
                <template v-slot:icon>
                    <img src="/img/iconos/icon_calendar.svg" alt="Calendario">
                </template>
                <template v-slot:info>
                    <img v-b-modal.modal-fechaentrega src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                    <modal-block v-cloak title="Fecha de entrega" :href="route('help.details','calendario-de-entrega')"  desing="ecologico" refer="fechaentrega">
                        Fecha en la que recibirás la variedad seleccionada.<br>
                        Los envíos salen de Babyplant los martes.
                    </modal-block>
                </template>
                <template v-slot:extra v-if="changingFecha">
                    <custom-date-picker v-model="edited.date" :block-to="blockToDate"></custom-date-picker>
                </template>
            </budget-line>
            <budget-line-quantity :tray-formats-data="trayFormatsDataFilled"
                                  :tray-price-base="trayPriceBase" :seed-price="seedPrice"
                                  :min-order="minOrder" :seed-lost-percent="seedLostPercent"
                                  :has-price="hasPrice" @changed-num-plants="numPlantsChanged"
                                  :seeds-by-alveolus.sync="edited.seedsByAlveolus"
                                  :bp-recommended-seeds-by-alveolus="recommendedSeedsByAlveolus"
                                  :bp-recommended-tray-format-id="recommendedTrayFormatId"
                                  :injerto="injertada"
                                  @total-price-changed="totalPriceChanged" :num-plants="numPlants"
                                  @click-back-varieties-min-order="clickBackVarietiesMinOrder"
                                  :max-seeds-by-alveolus="maxSeedsByAlveolus" ref="quantityLine"
                                  @choose-other-variety="chooseOtherVariety" :changing-line.sync="changingQuantity"
            ></budget-line-quantity>
        </template>
        <template v-slot:modal-footer>
            <div :id="popoverId">
                <button class="btn ok-btn" :disabled="disableUpdate" @click="save">
                    <b-spinner small v-if="saving"></b-spinner> Actualizar
                </button>
            </div>
            <b-popover v-if="showPopoverInfo" :target="popoverId" triggers="hover" placement="top" variant="danger">
                <template v-slot:title>
                    Corrige los siguientes datos
                </template>
                <ul>
                    <li v-if="numPlants < 1">
                        <b-button @click="pickQuantity" size="sm" variant="success">Selecciona cantidad y formato</b-button>
                    </li>
                    <li v-if="dateProblem">
                        No llegamos a tiempo a servir en la fecha indicada.
                        <b-button @click="otherDate" size="sm" variant="success">Selecciona otra fecha disponible</b-button>
                    </li>
                    <li v-if="edited.injerto && !edited.varietyPieId">
                        <b-button @click="pickInjerto" size="sm" variant="success">Selecciona la variedad pie</b-button>
                    </li>
                </ul>
            </b-popover>
            <button class="btn cancel-btn" @click="editModalShow = false" :disabled="saving">
                Cancelar
            </button>
        </template>
    </b-modal>
</template>

<script>
    import BudgetLine from "./BudgetLine";
    import EcoTypeButtons from "./EcoTypeButtons";
    import InjertoTypeButtons from "./InjertoTypeButtons";
    import VarietySelectInput from "./VarietySelectInput";
    import BudgetLineQuantity from "./BudgetLineQuantity";
    import CustomDatePicker from "./CustomDatePicker";
    import ChangedDateVariety from "./ChangedDateVariety";
    import ChangeDateVariety from "./ChangeDateVariety";
    import InjertoSelectInput from "./InjertoSelectInput";
    import { v4 as uuidv4 } from 'uuid';

    export default {
        name: "EditBudgetLineModal",
        components: {
            InjertoSelectInput,
            ChangeDateVariety,
            ChangedDateVariety,
            CustomDatePicker,
            BudgetLineQuantity, VarietySelectInput, InjertoTypeButtons, EcoTypeButtons, BudgetLine},
        props: {
            budgetLine: {
                type: Object
            },
            trayFormatsData: {
                type: Array
            },
            trayPricesBase: {
                type: Object
            }
        },
        data() {
            return {
                edited: {
                    eco: null,
                    injerto: null,
                    date: null,
                    varietyId: null,
                    varietyPieId: null,
                    seedsByAlveolus: null
                },
                changingEcoType: false,
                changingInjertoType: false,
                changingFecha: false,
                changingVariety: false,
                changingVarietyPie: false,
                changingQuantity: false,
                trayFormatsDataFilled: [],
                variety: null,
                varietyPie: null,
                numPlants: 0,
                saving: false,
                totalPrice: 0,
                dateChanged: null,
                dateProblem: false,
                dateBlock: moment().startOf('day').toDate(),
                showMinOrder: false,
                filters: null,
                noPriceInjerto: false,
                popoverId: uuidv4()
            }
        },
        computed: {
            editModalShow: {
                set(value) {
                    if (!value) {
                        this.$emit('edited');
                    }
                },
                get() {
                    return this.budgetLine !== null;
                }
            },
            eco() {
                return this.edited.eco;
            },
            injertada() {
                return this.edited.injerto;
            },
            date() {
                return this.edited.date;
            },
            dateFormatted() {
                return moment(this.date).format('D [de] MMMM [de] YYYY')
            },
            budgetData() {
                return this.budgetLine;
            },
            trayPriceBase() {
                let price;
                let prices = this.trayPricesBase;
                if (this.variety && this.variety.calefaccion) {
                    if (this.eco) {
                        price = prices.eco_calefaccion;
                    } else {
                        price = prices.conv_calefaccion;
                    }
                } else {
                    if (this.eco) {
                        price = prices.eco_no_calefaccion;
                    } else {
                        price = prices.conv_no_calefaccion;
                    }
                }
                if (this.varietyPie) {
                    price += this.varietyPie.incremento_fijo_bandeja;
                }
                return price;
            },
            seedPrice() {
                let seedPrice = null;
                if (this.variety) {
                    if (this.eco) {
                        seedPrice = this.variety.seed_price_eco;
                    } else {
                        seedPrice = this.variety.seed_price_convencional;
                    }
                    if (seedPrice !== null && this.varietyPie) {
                        let seedPriceInjerto;
                        if (this.eco) {
                            seedPriceInjerto = this.varietyPie.seed_price_eco;
                        } else {
                            seedPriceInjerto = this.varietyPie.seed_price_convencional;
                        }
                        if (seedPriceInjerto !== null) {
                            seedPrice += seedPriceInjerto;
                        } else {
                            seedPrice = null;
                        }
                    }
                }
                return seedPrice;
            },
            minOrder() {
                let minOrder = null;
                if (this.variety) {
                    minOrder = this.variety.min_order;
                }
                return minOrder;
            },
            seedLostPercent() {
                let seedLostPercent = null;
                if (this.variety) {
                    seedLostPercent = parseInt(this.variety.seed_lost_percent);
                    if (this.varietyPie) {
                        seedLostPercent = parseInt(this.varietyPie.seed_lost_percent);
                    }
                }
                return seedLostPercent;
            },
            hasPrice() {
                return this.seedPrice !== null;
            },
            disableUpdate() {
                return this.numPlants < 1 || this.dateProblem || this.saving ||
                    (this.edited.injerto && !this.edited.varietyPieId);
            },
            showPopoverInfo() {
                return this.numPlants < 1 || this.dateProblem ||
                    (this.edited.injerto && !this.edited.varietyPieId);
            },
            recommendedSeedsByAlveolus() {
                let recommendedSeedsByAlveolus = 1;
                if (this.variety) {
                    recommendedSeedsByAlveolus = this.variety.recommended_seeds_by_alveolus;
                }
                return recommendedSeedsByAlveolus;
            },
            recommendedTrayFormatId() {
                let recommendedTrayFormatId = null;
                if (this.variety) {
                    recommendedTrayFormatId = this.variety.recommended_tray_format_id;
                }
                return recommendedTrayFormatId;
            },
            blockToDate() {
                return moment(this.dateBlock).toDate();
            },
            budgetLineDate() {
                return moment(this.edited.date).toDate();
            },
            maxSeedsByAlveolus() {
                let maxSeedsByAlveolus = window.custom.params.max_seeds_by_alveolus;
                if (this.edited.injerto) {
                    maxSeedsByAlveolus = window.custom.params.max_seeds_by_alveolus_injerto;
                }
                return maxSeedsByAlveolus;
            },
            canInjerto() {
                let can = false;
                if (this.variety) {
                    can = !!this.variety.injertable;
                }
                return can;
            },
            forceTipoPlanta() {
                return this.budgetData.force_tipo_planta;
            }
        },
        watch: {
            budgetLine() {
                this.changingEcoType = false;
                this.changingInjertoType = false;
                this.changingFecha = false;
                this.changingVariety = false;
                this.changingVarietyPie = false;
                this.changingQuantity = false;
                this.resetEditedData();
                this.setTrayFormatValues();
                let variety = null;
                if (this.budgetLine) {
                    variety = this.budgetLine.variety;
                }
                this.variety = variety;
                let varietyPie = null;
                if (this.budgetLine) {
                    varietyPie = this.budgetLine.varietyPie;
                }
                this.varietyPie = varietyPie;
                let dateBlock = moment().startOf('day').toDate();
                if (this.budgetLine) {
                    dateBlock = this.budgetLine.block_to_date;
                }
                this.dateBlock = dateBlock;
                this.dateChanged = null;
                let numPlants = 0;
                if (this.budgetLine) {
                    numPlants = this.budgetLine.num_plants;
                }
                this.numPlants = numPlants;
                this.showMinOrder = false;
                let filters = null;
                if (this.budgetLine) {
                    filters = Object.assign({}, this.budgetLine.filters);
                }
                this.filters = filters;
            },
            trayFormatsData() {
                this.setTrayFormatValues();
            },
            minOrder(newValue, oldValue) {
                if (newValue !== oldValue && oldValue !== null && newValue !== null) {
                    this.resetQuantities();
                }
            },
            hasPrice(newVal) {
                if (!newVal) {
                    this.resetQuantities();
                }
            },
            variety(newVal, oldVal) {
                if (oldVal && newVal) {
                    this.varietyPie = null;
                    this.edited.varietyPieId = null;
                }
                this.$store.commit('custom/setVarietySelected', newVal);
            },
            varietyPie(newVal) {
                this.$store.commit('custom/setVarietyPieSelected', newVal);
            },
            injertada(newVal, oldVal) {
                if (this.variety) {
                    if (newVal && !this.variety.injertable) {
                        this.variety = null;
                        this.edited.varietyId = null;
                    }
                }
                if (!newVal && oldVal) {
                    this.varietyPie = null;
                    this.edited.varietyPieId = null;
                }
            },
            canInjerto(newVal) {
                if (!newVal) {
                    this.edited.injerto = false;
                    this.varietyPie = null;
                    this.edited.varietyPieId = null;
                }
            },
            filters: {
                deep: true,
                handler(newVal, oldVal) {
                    if (this.budgetLine) {
                        this.budgetLine.filters = newVal;
                    }
                }
            },
            date() {
                this.dateProblem = false;
            },
            changingQuantity(val) {
                if (val && this.budgetLine.duplicated) {
                    this.edited.seedsByAlveolus = 1;
                    this.trayFormatsDataFilled.forEach(tf => tf.value = 0);
                }
            }
        },
        methods: {
            changeTipoPlanta() {
                this.changingEcoType = !this.changingEcoType;
            },
            changeInjertoPlanta() {
                this.changingInjertoType = !this.changingInjertoType;
            },
            changeFecha() {
                this.changingFecha = !this.changingFecha;
            },
            changeVariety() {
                this.changingVariety = !this.changingVariety;
            },
            changeVarietyPie() {
                this.changingVarietyPie = !this.changingVarietyPie;
            },
            resetEditedData() {
                let budgetLine = this.budgetLine;
                let eco = null;
                let injerto = null;
                let date = null;
                let varietyId = null;
                let varietyPieId = null;
                let seedsByAlveolus = null
                if (budgetLine) {
                    eco = !!this.budgetLine.eco_type;
                    injerto = !!this.budgetLine.injerto_type;
                    date = this.budgetLine.date;
                    varietyId = this.budgetLine.variety_id;
                    varietyPieId = this.budgetLine.variety_pie_id;
                    seedsByAlveolus = this.budgetLine.seeds_by_alveolus;
                }
                this.edited.eco = eco;
                this.edited.injerto = injerto;
                this.edited.date = date;
                this.edited.varietyId = varietyId;
                this.edited.varietyPieId = varietyPieId;
                this.edited.seedsByAlveolus = seedsByAlveolus;
            },
            setTrayFormatValues() {
                let trayFormats = this.trayFormatsData;
                trayFormats.forEach(tf => {
                    let value = 0;
                    if (this.budgetLine) {
                        this.budgetLine.trays.forEach(t => {
                            if (tf.id === t.tray.id) {
                                value = t.num_trays;
                            }
                        });
                    }
                    tf.value = value;
                });
                this.trayFormatsDataFilled = trayFormats;
            },
            setVarietyObj(variety) {
                this.variety = variety;
            },
            setVarietyPieObj(variety) {
                this.varietyPie = variety;
            },
            numPlantsChanged(value) {
                this.numPlants = value;
            },
            resetQuantities() {
                this.trayFormatsData.forEach(tf => {
                    tf.value = 0;
                });
                this.numPlants = 0;
                this.edited.seedsByAlveolus = 1;
            },
            totalPriceChanged(value) {
                this.totalPrice = value;
            },
            save() {
                let vm = this;
                vm.changingVariety = vm.changingVarietyPie = vm.changingFecha = vm.changingInjertoType = vm.changingEcoType = vm.changingQuantity = false;
                vm.saving = true;
                let formData = new FormData();
                formData.append('update_line', 1);
                formData.append('id', vm.budgetLine.id);
                formData.append('eco', vm.edited.eco ? 1 : 0);
                formData.append('injerto', vm.edited.injerto ? 1 : 0);
                formData.append('date', vm.edited.date);
                formData.append('variety_id', vm.variety.id);
                if (vm.edited.injerto) {
                    formData.append('variety_pie_id', vm.varietyPie.id);
                }
                formData.append('num_plants', vm.numPlants);
                formData.append('seeds_by_alveolus', vm.edited.seedsByAlveolus);
                formData.append('tray_formats', JSON.stringify(vm.trayFormatsData));
                formData.append('total_price', vm.totalPrice.toFixed(12));
                axios.post(vm.route('custom.summary-next'), formData).then((response) => {
                    let budgetLine = response.data.budgetLine;
                    this.saved(budgetLine);
                }).catch(e => {
                    Vue.toasted.error("Error al enviar los datos al servidor", {
                        duration: 3000
                    });
                    console.error(e);
                }).finally(() => {
                    vm.saving = false;
                });
            },
            saved(budgetLine) {
                let vm = this;
                vm.budgetLine.eco_type = vm.edited.eco;
                vm.budgetLine.injerto_type = vm.edited.injerto;
                vm.budgetLine.date = vm.edited.date;
                vm.budgetLine.variety = vm.variety;
                vm.budgetLine.varietyPie = vm.varietyPie;
                vm.budgetLine.num_plants = vm.numPlants;
                vm.budgetLine.seeds_by_alveolus = vm.edited.seedsByAlveolus;
                vm.budgetLine.trays = vm.trayFormatsData.filter(tf => tf.value > 0).map(tf => {
                    return {
                        num_trays: tf.value,
                        tray: {
                            id: tf.id,
                            nombre: tf.nombre,
                            unidades: tf.unidades
                        }
                    }
                });
                vm.budgetLine.total_price = vm.totalPrice;
                // this.$emit('updated', budgetLine);
                vm.editModalShow = false;
            },
            otherDate() {
                this.changingFecha = true;
                this.$refs.dateLine.$el.scrollIntoView();
            },
            pickQuantity() {
                this.changingQuantity = true;
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.$refs.quantityLine.$el.scrollIntoView();
                    });
                });
            },
            pickInjerto() {
                this.changingVarietyPie = true;
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.$refs.varietyPieLine.$el.scrollIntoView();
                    });
                });
            },
            dateProblemChanged(value) {
                this.dateProblem = value;
            },
            dateSelected(date) {
                this.edited.date = moment(date).format('YYYY-MM-DD');
                this.dateChanged = date;
            },
            dateBlockChanged(value) {
                this.dateBlock = value;
            },
            clickBackVarietiesMinOrder() {
                this.showMinOrder = true;
                this.changingVariety = true;
                this.$refs.varietyLine.$el.scrollIntoView();
            },
            chooseOtherVariety() {
                this.changingVariety = true;
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.$refs.varietyLine.$el.scrollIntoView();
                    });
                });
            }
        },
        created() {
            this.setTrayFormatValues();
        }
    }
</script>

<style scoped>

</style>

<style>
    .c-edit-budget-line .modal-header {
        background: #0871b8;
        color: white;
        border-radius: 0;
        padding: 0.5rem 1rem;
    }

    .c-edit-budget-line .modal-body {
        overflow-x: hidden;
    }

    .c-edit-budget-line .modal-header .close {
        color: white;
        text-shadow: none;
        opacity: 1;
    }

    .c-edit-budget-line .modal-footer {
        justify-content: center;
    }

    .c-edit-budget-line .modal-footer .btn {
        padding: 0.175rem 2rem;
    }

    .c-edit-budget-line .modal-footer .ok-btn {
        font-size: 17px;
        font-weight: bold;
        padding: 5px 15px;
        margin-top: 10px;
        color: #ffffff;
        background-color: #ff3366;
        border-color: #db2d49;
        border-width: 2px;
        border-radius: 0;
        margin-bottom: 0.5em;
    }

    .c-edit-budget-line .modal-footer .ok-btn:hover {
        background-color: #db2d49;
    }

    .c-edit-budget-line .modal-footer .cancel-btn {
        font-size: 17px;
        font-weight: bold;
        padding: 5px 15px;
        margin-top: 10px;
        color: #2d2d2d;
        border-color: #1c1c1c;
        border-width: 2px;
        border-radius: 0;
        margin-bottom: 0.5em;
        margin-right: 0.7em;
    }

    .c-edit-budget-line .modal-footer .ok-btn:disabled,
    .c-edit-budget-line .modal-footer .cancel-btn:disabled {
        background-color: #b4b3b3;
        color: #808081;
        border-color: #808081;
        opacity: 1;
    }
</style>
